import React from "react";
import { Table } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import { Link } from "react-router-dom";
import { CardBody } from "../../../../../../_metronic/_partials/controls";
import { CORPORATION } from "../../../../../config/environment";
import {
  checkRoleCorp,
  CORPS,
  organizationStatusFormatter
} from "../../../../../config/helper";

export default function OrganizationDetailForm({ data = {} }) {
  const {
    address,
    call_center,
    city,
    country,
    created_at,
    current_quota_email,
    current_quota_sms,
    district,
    domain_name,
    email,
    facebook,
    file_uuid,
    instagram,
    is_activated,
    is_wizard,
    last_generated_invoice_date,
    name,
    name_sender,
    plan_payment_date,
    plan_payment_status,
    plan_uuid,
    postal_code,
    province,
    quota_email,
    quota_sms,
    registration_date,
    sequense_prefix,
    status,
    trial_status,
    twitter,
    updated_at,
    uuid,
    whatsapp,
    user
  } = data;

  return (
    <>
      <CardBody>
        <div className="row mb-5">
          <div className="col">
            <table>
              <tr>
                <td className="py-3 pr-3">Domain</td>
                <td className="py-3 pr-3">:</td>
                <td className="py-3 pr-3">
                  <span
                    style={{ cursor: "pointer", textDecoration: "underline" }}
                    onClick={() => window.open(`https://${domain_name}`)}
                  >
                    {domain_name}
                  </span>
                </td>
              </tr>
              <tr>
                <td className="py-3 pr-3">Nama PIC</td>
                <td className="py-3 pr-3">:</td>
                <td className="py-3 pr-3">{user && user.name}</td>
              </tr>
              <tr>
                <td className="py-3 pr-3">No HP PIC</td>
                <td className="py-3 pr-3">:</td>
                <td className="py-3 pr-3">{call_center}</td>
              </tr>
              {/* <tr>
                <td className="py-3 pr-3">Alamat</td>
                <td className="py-3 pr-3">:</td>
                <td className="py-3 pr-3">
                  {`${district ? `${district}` : ""} ${
                    city ? `, ${city}` : ""
                  } ${province ? `, ${province}` : ""}`}
                  {address && <span>, {address}</span>}
                  {postal_code && <span>, {postal_code}</span>}
                </td>
              </tr> */}
              <tr>
                <td className="py-3 pr-3">Email PIC</td>
                <td className="py-3 pr-3">:</td>
                <td className="py-3 pr-3">{email}</td>
              </tr>
              {/* STATUS PEMBAYARAN HILANG JIKA CORP SIMPZ */}
              {checkRoleCorp(CORPORATION, "organization_payment_status") && (
                <tr>
                  <td className="py-3 pr-3">Status Pembayaran</td>
                  <td className="py-3 pr-3">:</td>
                  <td className="py-3 pr-3">
                    {organizationStatusFormatter(plan_payment_status)}
                  </td>
                </tr>
              )}
              <tr>
                <td className="py-3 pr-3">Tanggal Pendaftaran</td>
                <td className="py-3 pr-3">:</td>
                <td className="py-3 pr-3">{registration_date}</td>
              </tr>
            </table>
          </div>
        </div>
      </CardBody>
    </>
  );
}
